<template>
  <div>
    <p>
      <b>4.</b> Forma pomocy (kol. 4) - należy podać wyłącznie kod oznaczający właściwą formę pomocy.
    </p>

    <table width="100%" border="1">
      <tr>
        <th>
          <b>Forma pomocy</b>
        </th>

        <th>
          <b>Kod</b>
        </th>
      </tr>

      <tr>
        <td>
          <b>1</b>
        </td>

        <td>
          <b>2</b>
        </td>
      </tr>

      <class-row help-form="dotacja" code="A1.1" />

      <class-row
        help-form="dopłaty do oprocentowania kredytów bankowych (bezpośrednio dla przedsiębiorców)"
        code="A1.2"
      />

      <class-row
        help-form="inne wydatki związane z funkcjonowaniem jednostek budżetowych lub realizacją ich zadań statutowych"
        code="A1.3"
      />

      <class-row help-form="refundacja" code="A1.4" />

      <class-row help-form="rekompensata" code="A1.5" />

      <class-row help-form="zwolnienie z podatku" code="A2.1" />

      <class-row help-form="odliczenie od podatku" code="A2.2" />

      <class-row
        help-form="obniżka lub zmniejszenie, powodujące obniżenie podstawy opodatkowania lub wysokości podatku"
        code="A2.3"
      />

      <class-row help-form="obniżenie wysokości opłaty" code="A2.4" />

      <class-row help-form="zaniechanie poboru podatku" code="A2.6" />

      <class-row help-form="zaniechanie poboru opłaty" code="A2.7" />

      <class-row help-form="umorzenie zaległości podatkowej wraz z odsetkami" code="A2.8" />

      <class-row help-form="umorzenie odsetek od zaległości podatkowej" code="A2.9" />

      <class-row help-form="umorzenie opłaty (składki, wpłaty)" code="A2.10" />

      <class-row
        help-form="umorzenie odsetek za zwłokę z tytułu opłaty (składki, wpłaty)"
        code="A2.11"
      />

      <class-row help-form="umorzenie kar" code="A2.12" />

      <class-row
        help-form="oddanie do korzystania mienia będącego własnością Skarbu Państwa albo jednostek samorządu terytorialnego lub ich związków na warunkach korzystniejszych dla przedsiębiorcy od oferowanych na rynku"
        code="A2.13"
      />

      <class-row
        help-form="zbycie mienia będącego własnością Skarbu Państwa albo jednostek samorządu terytorialnego lub ich związków na warunkach korzystniejszych od oferowanych na rynku"
        code="A2.14"
      />

      <class-row help-form="umorzenie kosztów egzekucyjnych" code="A2.15" />

      <class-row help-form="jednorazowa amortyzacja" code="A2.16" />

      <class-row help-form="umorzenie kosztów procesu sądowego" code="A2.17" />

      <class-row help-form="wniesienie kapitału" code="B1.1" />

      <class-row help-form="konwersja wierzytelności na akcje lub udziały" code="B2.1" />

      <class-row help-form="pożyczka preferencyjna" code="C1.1" />

      <class-row help-form="kredyt preferencyjny" code="C1.2" />

      <class-row help-form="dopłaty do oprocentowania kredytów bankowych (dla banków)" code="C1.3" />

      <class-row help-form="pożyczki warunkowo umorzone" code="C1.4" />

      <class-row help-form="odroczenie terminu płatności podatku" code="C2.1" />

      <class-row
        help-form="odroczenie terminu płatności zaległości podatkowej lub zaległości podatkowej wraz z odsetkami"
        code="C2.1.2"
      />

      <class-row
        help-form="rozłożenie na raty płatności zaległości podatkowej lub zaległości podatkowej wraz z odsetkami"
        code="C2.3.1"
      />

      <class-row help-form="odroczenie terminu płatności opłaty (składki, wpłaty)" code="C2.4" />

      <class-row
        help-form="odroczenie terminu płatności zaległej opłaty (składki, wpłaty) lub zaległej opłaty (składki, wpłaty) wraz z odsetkami"
        code="C2.4.1"
      />

      <class-row help-form="rozłożenie na raty opłaty (składki, wpłaty)" code="C2.5" />

      <class-row
        help-form="rozłożenie na raty płatności zaległej opłaty (składki, wpłaty) lub zaległej opłaty (składki, wpłaty) wraz z odsetkami"
        code="C2.5.1"
      />

      <class-row help-form="odroczenie terminu płatności kary" code="C2.6" />

      <class-row help-form="rozłożenie na raty kary" code="C2.7" />

      <class-row help-form="rozłożenie na raty kosztów egzekucyjnych" code="C2.8" />

      <class-row help-form="rozłożenie na raty odsetek" code="C2.9" />

      <class-row help-form="odroczenie terminu płatności kosztów egzekucyjnych" code="C2.10" />

      <class-row help-form="odroczenie terminu płatności odsetek" code="C2.11" />

      <class-row help-form="odroczenie terminu płatności kosztów procesu sądowego" code="C2.12" />

      <class-row help-form="rozłożenie na raty kosztów procesu sądowego" code="C2.13" />

      <class-row help-form="poręczenie" code="D1.1" />

      <class-row help-form="gwarancja" code="D1.2" />

      <class-row help-form="inne" code="E" />
    </table>

    <br />

    <p>
      <b>5.</b> Wartość otrzymanej pomocy publicznej lub pomocy de minimis (kol. 5a i 5b) - należy podać:
    </p>

    <p>
      a) wartość nominalną pomocy (jako całkowitą wielkość środków finansowych będących podstawą do obliczania wielkości
      udzielonej pomocy, np. kwota udzielonej pożyczki lub kwota odroczonego podatku) oraz
    </p>

    <p>
      b) wartość brutto (jako ekwiwalent dotacji brutto obliczony zgodnie z rozporządzeniem Rady Ministrów wydanym na
      podstawie art. 11 ust. 2 ustawy z dnia 30 kwietnia 2004 r. o postępowaniu w sprawach dotyczących pomocy publicznej
      oraz właściwymi przepisami unijnymi).
    </p>

    <p>
      <b>6.</b> Przeznaczenie pomocy publicznej (kol. 6) - należy podać kod wskazujący przeznaczenie otrzymanej pomocy
      według poniższej tabeli.
    </p>

    <table width="100%" border="1">
      <tr>
        <th>
          <b>Wyszczególnienie</b>
        </th>

        <th>
          <b>Kod</b>
        </th>
      </tr>

      <tr>
        <td>
          <b>1</b>
        </td>

        <td>
          <b>2</b>
        </td>
      </tr>

      <tr>
        <td class="border-right-0">
          <b>A. POMOC HORYZONTALNA</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <tr>
        <td class="border-right-0">
          <b>Pomoc na działalność badawczą, rozwojową i innowacyjną</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="pomoc na projekty badawczo-rozwojowe: badania podstawowe" code="a1.1.1" />

      <class-row
        help-form="pomoc na projekty badawczo-rozwojowe: badania przemysłowe"
        code="a1.1.2"
      />

      <class-row
        help-form="pomoc na projekty badawczo-rozwojowe: eksperymentalne prace rozwojowe"
        code="a1.1.3"
      />

      <class-row help-form="pomoc dla młodych innowacyjnych przedsiębiorstw" code="a1.2" />

      <class-row help-form="pomoc na techniczne studia wykonalności" code="a1.3" />

      <class-row
        help-form="pomoc na innowacje w obrębie procesów i innowacje organizacyjne w sektorze usług"
        code="a1.4"
      />

      <class-row
        help-form="pomoc na usługi doradcze w zakresie innowacji i usługi wsparcia innowacji"
        code="a1.5"
      />

      <class-row
        help-form="pomoc na tymczasowe zatrudnienie wysoko wykwalifikowanego personelu"
        code="a1.6"
      />

      <class-row help-form="pomoc na klastry innowacyjne" code="a1.7" />

      <class-row
        help-form="pomoc na pokrycie kosztów praw własności przemysłowej dla małych i średnich przedsiębiorstw"
        code="a1.8"
      />

      <tr>
        <td class="border-right-0">
          <b>Pomoc na ochronę środowiska</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row
        help-form="pomoc inwestycyjna umożliwiająca przedsiębiorstwom dostosowanie do norm wspólnotowych (zgodnie z załącznikiem XII Traktatu o przystąpieniu Rzeczpospolitej Polskiej do Unii Europejskiej), zastosowanie norm surowszych niż normy wspólnotowe w zakresie ochrony środowiska lub podniesienie poziomu ochrony środowiska w przypadku braku norm wspólnotowych"
        code="a2.1"
      />

      <class-row
        help-form="pomoc na nabycie nowych środków transportu spełniających normy surowsze niż normy wspólnotowe lub podnoszących poziom ochrony środowiska w przypadku braku norm wspólnotowych"
        code="a2.2"
      />

      <class-row
        help-form="pomoc na wcześniejsze dostosowanie przedsiębiorstw do przyszłych norm wspólnotowych"
        code="a2.3"
      />

      <class-row
        help-form="pomoc w obszarze ochrony środowiska na inwestycje zwiększające oszczędność energii, w tym pomoc operacyjna"
        code="a2.4"
      />

      <class-row
        help-form="pomoc inwestycyjna w obszarze ochrony środowiska na układy kogeneracji o wysokiej sprawności, w tym pomoc operacyjna"
        code="a2.5"
      />

      <class-row
        help-form="pomoc inwestycyjna w obszarze ochrony środowiska na propagowanie energii ze źródeł odnawialnych, w tym pomoc operacyjna"
        code="a2.6"
      />

      <class-row help-form="pomoc na badania środowiska" code="a2.7" />

      <class-row help-form="pomoc na ochronę środowiska w formie ulg podatkowych" code="a2.8" />

      <class-row help-form="pomoc na efektywne energetycznie ciepłownictwo komunalne" code="a2.9" />

      <class-row help-form="pomoc na gospodarowanie odpadami" code="a2.10" />

      <class-row help-form="pomoc na rekultywację zanieczyszczonych terenów" code="a2.11" />

      <class-row help-form="pomoc na relokację przedsiębiorstw" code="a2.12" />

      <class-row help-form="pomoc dotycząca programów handlu uprawnieniami" code="a2.13" />

      <tr>
        <td class="border-right-0">
          <b>Pomoc inwestycyjna i na zatrudnienie dla małych i średnich przedsiębiorstw</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="pomoc inwestycyjna" code="a3" />

      <class-row help-form="pomoc na zatrudnienie" code="a4" />

      <tr>
        <td class="border-right-0">
          <b>
            Pomoc na usługi doradcze dla małych i średnich przedsiębiorstw oraz udział małych i średnich
            przedsiębiorstw w targach
          </b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="pomoc na usługi doradcze" code="a5" />

      <class-row help-form="pomoc na udział w targach" code="a6" />

      <tr>
        <td class="border-right-0">
          <b>
            Pomoc dla pracowników znajdujących się w szczególnie niekorzystnej sytuacji oraz pracowników
            niepełnosprawnych
          </b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row
        help-form="pomoc w formie subsydiów płacowych na rekrutację pracowników znajdujących się w szczególnie niekorzystnej sytuacji"
        code="a11"
      />

      <class-row
        help-form="pomoc w formie subsydiów płacowych na zatrudnianie pracowników niepełnosprawnych"
        code="a12"
      />

      <class-row
        help-form="pomoc na rekompensatę dodatkowych kosztów związanych z zatrudnianiem pracowników niepełnosprawnych"
        code="a13"
      />

      <tr>
        <td class="border-right-0">
          <b>Pomoc szkoleniowa</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="szkolenia specjalistyczne" code="a14.1" />

      <class-row help-form="szkolenia ogólne" code="a14.2" />

      <class-row help-form="Pomoc na ratowanie" code="a15" add-property="font-weight-bold" />

      <class-row help-form="Pomoc na restrukturyzację" code="a16" add-property="font-weight-bold" />

      <class-row
        help-form="Pomoc udzielana na naprawienie szkód wyrządzonych przez klęski żywiołowe lub inne nadzwyczajne zdarzenia"
        code="a17"
        add-property="font-weight-bold"
      />

      <class-row
        help-form="Pomoc udzielana na zapobieżenie lub likwidację poważnych zakłóceń w gospodarce o charakterze ponadsektorowym"
        code="a18"
        add-property="font-weight-bold"
      />

      <class-row
        help-form="Pomoc udzielana na wsparcie krajowych przedsiębiorców działających w ramach przedsięwzięcia gospodarczego podejmowanego w interesie europejskim"
        code="a19"
        add-property="font-weight-bold"
      />

      <class-row
        help-form="Pomoc na wspieranie kultury i zachowanie dziedzictwa kulturowego"
        code="a20"
        add-property="font-weight-bold"
      />

      <class-row
        help-form="Pomoc o charakterze socjalnym dla indywidualnych konsumentów"
        code="a21"
        add-property="font-weight-bold"
      />

      <class-row
        help-form="Pomoc w formie kapitału podwyższonego ryzyka"
        code="a22"
        add-property="font-weight-bold"
      />

      <class-row
        help-form="Pomoc przeznaczona na ułatwianie rozwoju niektórych działań gospodarczych lub niektórych regionów gospodarczych, o ile nie zmienia warunków wymiany handlowej w zakresie sprzecznym z rynkiem wewnętrznym"
        code="a23"
        add-property="font-weight-bold"
      />

      <class-row
        help-form="Pomoc na rzecz małych przedsiębiorstw nowo utworzonych przez kobiety"
        code="a24"
        add-property="font-weight-bold"
      />

      <tr>
        <td class="border-right-0">
          <b>B. POMOC REGIONALNA</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="pomoc inwestycyjna" code="b1" />

      <class-row help-form="pomoc na zatrudnienie" code="b2" />

      <class-row help-form="regionalna pomoc inwestycyjna na duże projekty inwestycyjne" code="b3" />

      <class-row help-form="pomoc operacyjna" code="b4" />

      <class-row help-form="pomoc dla nowo utworzonych małych przedsiębiorstw" code="b5" />

      <tr>
        <td class="border-right-0">
          <b>C. INNE PRZEZNACZENIE</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row
        help-form="pomoc stanowiąca rekompensatę za realizację usług świadczonych w ogólnym interesie gospodarczym"
        code="c5"
      />

      <class-row help-form="pomoc de minimis" code="e1" />

      <class-row
        help-form="pomoc de minimis w sektorze transportu drogowego udzielana zgodnie z rozporządzeniem Komisji nr 1998/2006 oraz pomoc de minimis w sektorze transportu drogowego towarów udzielana zgodnie z rozporządzeniem Komisji nr 1407/2013"
        code="e1t"
      />

      <class-row
        help-form="pomoc de minimis stanowiąca rekompensatę za realizację usług świadczonych w ogólnym interesie gospodarczym udzielana zgodnie z rozporządzeniem Komisji nr 360/2012"
        code="e1c"
      />

      <tr>
        <td class="border-right-0">
          <b>D. POMOC W SEKTORACH - przeznaczenia szczególne</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <tr>
        <td class="border-right-0">
          <b>SEKTOR BUDOWNICTWA OKRĘTOWEGO</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="pomoc na przedsięwzięcia innowacyjne" code="d2.1" />

      <class-row help-form="pomoc związana z kredytami eksportowymi" code="d2.2" />

      <class-row help-form="pomoc na rozwój" code="d2.3" />

      <class-row
        help-form="całkowite zaprzestanie prowadzenia działalności przez przedsiębiorcę"
        code="d2.4"
      />

      <class-row
        help-form="częściowe zaprzestanie prowadzenia działalności przez przedsiębiorcę"
        code="d2.5"
      />

      <tr>
        <td class="border-right-0">
          <b>SEKTOR GÓRNICTWA WĘGLA</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="pomoc na pokrycie kosztów nadzwyczajnych" code="d3.1" />

      <class-row
        help-form="pomoc na pokrycie kosztów produkcji bieżącej dla jednostek objętych planem likwidacji"
        code="d3.2"
      />

      <class-row
        help-form="pomoc na pokrycie kosztów produkcji bieżącej dla jednostek objętych planem dostępu do zasobów węgla"
        code="d3.3"
      />

      <class-row help-form="pomoc na inwestycje początkowe" code="d3.4" />

      <tr>
        <td class="border-right-0">
          <b>SEKTOR TRANSPORTU</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <tr>
        <td class="border-right-0">
          <b>ŻEGLUGA MORSKA</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="pomoc inwestycyjna" code="d4.1" />

      <class-row help-form="pomoc na poprawę konkurencyjności" code="d4.2" />

      <class-row help-form="pomoc na repatriację marynarzy" code="d4.3" />

      <class-row help-form="pomoc na wsparcie żeglugi bliskiego zasięgu" code="d4.4" />

      <tr>
        <td class="border-right-0">
          <b>LOTNICTWO</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="pomoc na budowę infrastruktury portu lotniczego" code="d5.1" />

      <class-row help-form="pomoc na usługi portu lotniczego" code="d5.2" />

      <class-row help-form="pomoc dla przewoźników na rozpoczęcie działalności" code="d5.3" />

      <tr>
        <td class="border-right-0">
          <b>SEKTOR KOLEJOWY</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row help-form="pomoc regionalna w celu zakupu lub modernizacji taboru" code="d6.1" />

      <class-row help-form="pomoc w celu anulowania długów" code="d6.2" />

      <class-row help-form="pomoc na koordynację transportu" code="d6.3" />

      <tr>
        <td class="border-right-0">
          <b>TRANSPORT MULTIMODALNY I INTERMODALNY</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <tr>
        <td class="border-right-0">
          <b>INNA POMOC W SEKTORZE TRANSPORTU</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <tr>
        <td class="border-right-0">
          <b>SEKTOR ENERGETYKI</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row
        help-form="pomoc na pokrycie kosztów powstałych u wytwórców w związku z przedterminowym rozwiązaniem umów długoterminowych sprzedaży mocy i energii elektrycznej"
        code="d8"
      />

      <tr>
        <td class="border-right-0">
          <b>SEKTOR KINEMATOGRAFII</b>
        </td>

        <td class="border-left-0" />
      </tr>

      <class-row
        help-form="pomoc dotycząca kinematografii i innych przedsięwzięć audio-wizualnych"
        code="d9"
      />

      <class-row help-form="SEKTOR TELEKOMUNIKACYJNY" code="d10" add-property="font-weight-bold" />
    </table>
  </div>
</template>

<script>
import ClassRow from './ClassRow';

// @vuese
// Tabela z instrukcją do części D
// @group staticComponents
export default {
  components: {
    ClassRow
  }
};
</script>
